import Layout4Admin1 from "components/layout/Layout4Admin1";
import Css from './Customer.module.css';
import ApiConection from "api_ref/ApiConection";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import { ConvertDateToText, DisplayPaging } from "components/MyControl";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UtilClass from "api_ref/UtilClass";

export default function PackageList(){
    const api = new ApiConection();
    const navigate = useNavigate();
    const util = new UtilClass();

    const [dataTable, setDataTable] = useState({
        arr_table: [],
        record_start: 0,
        record_end: 0,
        record_count: 0,
        page_count: 0
    });

    const [search, setSearch] = useState({
        code: '',
        name: '',
        package_type: '',
        effective_date_from: '',
        effective_date_to: '',
        expiry_date_from: '',
        expiry_date_to: '',
        create_date_to: '',
        active: '',
        page: util.getCombinedSessionStorage('/setting/package','page') ?? 1,
        size: util.getCombinedSessionStorage('/setting/package','size') ?? 10
    });
    
    const [filterDispaly, setFilterDisplay] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSetSearch = (name, value) => {
        setSearch(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSetDataTable = (name, value) => {
        setDataTable(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleQuickSearch = (event) => {
        const { name, value } = event.target;
        handleSetSearch('name', value);
        handleSetSearch('page', 1);
        handleSetSearch('size', search.size);
    }

    const handleSizeTableChange = (event) => {
        const { name, value } = event.target;

        util.setCombinedSessionStorage('/setting/package','page',1);
        util.setCombinedSessionStorage('/setting/package','size',value);

        handleSetSearch('page', 1);
        handleSetSearch('size', value);
    }

    const handlePagingChange = (page_no) => {

        util.setCombinedSessionStorage('/setting/package','page',page_no);

        handleSetSearch('page', page_no);
    }

    const handleFullSearch = (event) => {
        const { name, value } = event.target;
        handleSetSearch(name, value);
        handleSetSearch('page', 1);
        handleSetSearch('size', search.size);
    }

    const handleGotoDetail = (register_number) => {
        navigate(`detail/${register_number}`);
    }

    const handleCreate = () => {
        navigate('/setting/package/create')
    }

    const callApiPackage = async () => {
        setLoading(true);

        let data = {
            search: {
            },
            pagination: {
                page: search.page,
                size: search.size,
                order_by:'id',
                order_mode:'asc'
            }
        }

        if (search.name != '')
            data.search.name = search.name;

        if (search.code != '')
            data.search.code = search.code;

        if(search.package_type != '')
            data.search.package_type = search.package_type;

        if (search.effective_date_from != '')
            data.search.effective_date_from = search.effective_date_from;

        if (search.effective_date_to != '')
            data.search.effective_date_to = search.effective_date_to;

        if (search.expiry_date_from != '')
            data.search.expiry_date_from = search.expiry_date_from;

        if (search.expiry_date_to != '')
            data.search.expiry_date_to = search.expiry_date_to;

        if (search.active != '')
            data.search.active = (search.active == true || search.active == 'true');

        const response_pagination = await api.postData('api/package/pagination', data);
        //debugger;
        if (response_pagination.status == true) {
            handleSetDataTable('record_start', response_pagination.data.record_start);
            handleSetDataTable('record_count', response_pagination.data.record_count);
            handleSetDataTable('page_count', response_pagination.data.page_count);
        }
        const response_result = await api.postData('api/package/result', data);

        if (response_result.status == true) {
            handleSetDataTable('arr_table', response_result.data);
        } else {
            handleSetDataTable('arr_table', []);
        }

        let record_end = response_pagination.data.record_start + (search.size - 1);
        if (record_end > response_pagination.data.record_count) {
            record_end = response_pagination.data.record_count;
        }

        handleSetDataTable('record_end', record_end);

        setLoading(false);
    }

    useEffect(() => {
        if (search !== undefined) {
            const delay = setTimeout(() => {
                // เรียกใช้ฟังก์ชันสำหรับการคำนวณผลลัพธ์ที่ต้องการ
                callApiPackage();
            }, 500);

            return () => clearTimeout(delay);
        }
    }, [search]);

    return(
        <Layout4Admin1 role="admin">
            <div className={Css.Block_Transparent}>
                <div className={Css.Graph_Group}>
                    <div className={Css.Graph_Box + ' shadow'}>
                        <div className={Css.Content}>
                            <div className={Css.Header}>
                                <div className="d-flex">
                                    <h6 className="d-flex align-items-center">รายการแพ็กเกจ</h6>
                                    <div className="flex-fill">
                                        <Form.Group as={Row}>
                                            <Form.Label column sm={4} className="text-end">ค้นหา</Form.Label>
                                            <Col>
                                                <InputGroup>
                                                    <Form.Control placeholder="แพ็กเกจ" id={'txtQuickSearch'} value={search.name}
                                                        disabled={filterDispaly}
                                                        onChange={(event) => handleQuickSearch(event)} />
                                                    <Button variant="outline-secondary" onClick={event => setFilterDisplay(!filterDispaly)}>
                                                        {
                                                            filterDispaly === true &&
                                                            <i className="fa-solid fa-arrow-up-short-wide"></i>
                                                        }
                                                        {
                                                            filterDispaly === false &&
                                                            <i className="fa-solid fa-arrow-down-short-wide"></i>
                                                        }
                                                        <span></span>
                                                    </Button>
                                                    <Button>
                                                        <i className="fa-solid fa-magnifying-glass"></i>
                                                    </Button>
                                                </InputGroup>

                                            </Col>
                                        </Form.Group>
                                    </div>
                                </div>
                                {
                                    filterDispaly === true &&
                                    <div className="d-flex bg-">
                                        <div className="w-100 bg-light p-3">
                                            <Row className="mb-2">
                                                <Col>
                                                    <Form.Label>Code</Form.Label>
                                                    <Form.Control name={'code'} value={search.code} onChange={handleFullSearch} />
                                                </Col>
                                                <Col>
                                                    <Form.Label>แพ็กเกจ</Form.Label>
                                                    <Form.Control name={'name'} value={search.name} onChange={handleFullSearch} />
                                                </Col>
                                                <Col>
                                                    <Form.Label>ประเภท</Form.Label>
                                                    <Form.Control name={'package_type'} value={search.package_type} onChange={handleFullSearch} />
                                                </Col>
                                                <Col>
                                                <Form.Label>สถานะ</Form.Label>
                                                    <Form.Select name={'active'} value={search.active} onChange={handleFullSearch}>
                                                        <option value={''}>ทั้งหมด</option>
                                                        <option value={true}>อนุญาตใช้งาน</option>
                                                        <option value={false}>ไม่อนุญาตใช้งาน</option>
                                                    </Form.Select>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className={Css.Content + ' position-relative'}>
                                {
                                    loading &&
                                    <div className="position-absolute w-100 h-100 bg-white bg-opacity-50" style={{ zIndex: 5 }}>
                                        <div className="d-flex justify-content-center">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    </div>
                                }

                                <div className={Css.Content + ' position-relative'}>
                                    <Button variant="outline-success" className="d-flex justify-content-center" onClick={event => handleCreate()}>
                                        <i className="fa-solid fa-plus me-2 mt-1"></i>เพิ่มแพ็กเกจ
                                    </Button>
                                </div>

                                <div className="table-responsive border rounded">

                                    <table className="table text-nowrap mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th ></th>
                                                <th>#</th>
                                                <th className="text-start">Code</th>
                                                <th className="text-start">แพ็กเกจ</th>
                                                <th className="text-start">ประเภท</th>
                                                <th className="text-start">วันที่เริ่มต้น</th>
                                                <th className="text-start">วันที่สิ้นสุด</th>
                                                <th className="text-center">จำนวนผู้ใช้งาน</th>
                                                <th className="text-end">ราคา/ผู้ใช้</th>
                                                <th className="text-center">จำนวนพื้นที่ใช้งาน(GB)</th>
                                                <th className="text-end">ราคา/ 1 GB</th>
                                                
                                                <th className="text-end">ราคารวม</th>
                                                <th>สถานะ</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                dataTable.arr_table.length > 0 &&
                                                dataTable.arr_table.map((obj, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                <button className="btn btn-edit-icon" onClick={event => handleGotoDetail(obj.id)}>
                                                                    <i className="fa-solid fa-pen-to-square"></i>
                                                                </button>
                                                            </td>
                                                            <td>{dataTable.record_start + index}</td>
                                                            <td className="text-start">{obj?.code}</td>
                                                            <td className="text-start">{obj?.name}</td>
                                                            <td className="text-start">{obj?.package_type}</td>
                                                            <td className="text-center">{ConvertDateToText(obj?.effective_date) }</td>
                                                            <td className="text-center">{ConvertDateToText(obj?.expiry_date)}</td>
                                                            
                                                            <td className="text-center">{obj?.number_of_user}</td>
                                                            <td className="text-end">{obj?.price_of_user}</td>
                                                            
                                                            <td className="text-center">{obj?.number_of_storage}</td>
                                                            <td className="text-end">{obj?.price_of_storage}</td>
                                                            <td className="text-end">{obj?.total}</td>
                                                            <td className="text-center">{obj.active == true ? <i className="fa-regular fa-circle-check fs-6 text-success" title="สำเร็จ"></i>
                                                                : <i className="fa-regular fa-circle-xmark fs-6 text-danger" title="ไม่สำเร็จ"></i>}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <DisplayPaging rec_start={dataTable.record_start}
                                    rec_end={dataTable.record_end}
                                    rec_count={dataTable.record_count}
                                    onSizeChange={handleSizeTableChange}
                                    cur_page={search.page}
                                    size={search.size}
                                    page_count={dataTable.page_count}
                                    onPagingChange={handlePagingChange} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout4Admin1>
    )
}